// Source de vérité pour les offres d'emploi Tchatix.
// Importée par la liste (/recrutement) et les pages détail (/recrutement/:slug).
import { SITE_NAME, SITE_URL, DEFAULT_OG_IMAGE } from "@/components/Seo";

// Section = { title, blocks: [{ t: "p"|"ul", c: string | string[] }] }
export const JOBS = [
  {
    slug: "business-developer-ia-b2b",
    title: "Business Developer IA B2B (H/F) | Indépendant",
    location: "Télétravail",
    city: "France",
    region: "Télétravail",
    postalCode: "",
    contract: "Indépendant",
    type: "Freelance",
    remote: "Télétravail",
    employmentType: "CONTRACTOR",
    telecommute: true,
    datePosted: "2026-09-18",
    validThrough: "2026-12-31",
    excerpt:
      "Rejoignez l'aventure Tchatix : vendez l'écosystème IA complet pour les PME et ETI, en indépendant, avec une rémunération récurrente sans plafond.",
    intro: [
      "L'IA transforme les entreprises, c'est une certitude. Chez Tchatix, nous sommes spécialisés dans la création d'agents IA sur mesure pour les métiers des PME et des ETI. Concrètement, nous vendons l'écosystème IA et le service de mise en place, pour que les entreprises puissent utiliser l'IA simplement, en toute sécurité, et surtout que cela leur soit vraiment utile au quotidien.",
      "Notre plateforme permet de créer, partager, automatiser et piloter des équipes d'agents IA métier, en utilisant les meilleurs modèles du marché (GPT, Mistral, Gemini, Claude, Grok…) dans un environnement sécurisé et conforme RGPD. On connecte aussi tout ça aux logiciels clients, et on les accompagne de A à Z.",
      "Notre force ? On résout le casse-tête des outils IA dispersés. Avec Tchatix, vous vendez une plateforme qui centralise tous les modèles, des agents prêts à l'emploi (SEO, prospection, community manager...) ET sur mesure, le tout ouvert et modifiable par le client. Une base de données IA partagée, un espace d'automatisations No-code, une plateforme collaborative entre équipes. Bref, au lieu de vendre un outil de plus, vous vendez l'infrastructure IA complète de l'entreprise.",
      "Dans le cadre de notre développement, nous cherchons des Business Developers indépendants qui souhaitent construire un revenu récurrent sur un marché en pleine explosion.",
    ],
    sections: [
      {
        title: "Votre mission",
        blocks: [
          { t: "p", c: "Vous accompagnez les entreprises dans leur transition vers l'intelligence artificielle." },
        ],
      },
      {
        title: "Vos missions",
        blocks: [
          {
            t: "ul",
            c: [
              "Prospecter et développer votre portefeuille clients B2B.",
              "Obtenir des rendez-vous avec des dirigeants d'entreprise.",
              "Identifier leurs besoins.",
              "Présenter les solutions Tchatix.",
              "Accompagner les clients jusqu'à la signature.",
              "Fidéliser votre portefeuille et développer votre chiffre d'affaires.",
            ],
          },
          { t: "p", c: "Vous travaillez en autonomie, mais avec une équipe technique derrière vous, capable de développer et mettre en place les agents IA sur mesure adaptés à chaque client." },
        ],
      },
      {
        title: "Une rémunération sans plafond",
        blocks: [
          { t: "p", c: "Vous touchez :" },
          {
            t: "ul",
            c: [
              "Une commission sur chaque contrat signé.",
              "Des primes à la signature.",
            ],
          },
          { t: "p", c: "Et surtout une commission récurrente mensuelle sur chaque abonnement, tant que le client reste chez nous. Votre portefeuille devient une source de revenus qui augmente chaque mois." },
          { t: "p", c: "Les commissions sont récurrentes : votre portefeuille grossit chaque mois, et vos revenus avec. Pas de plafond, c'est vous qui construisez votre progression." },
          { t: "p", c: "Vous êtes indépendant (micro-entreprise, EURL, SASU… à vous de choisir). Vous gérez votre temps, votre secteur et votre rythme." },
        ],
      },
      {
        title: "Un accompagnement conçu pour votre réussite",
        blocks: [
          { t: "p", c: "Chez Tchatix, on ne vous laisse pas seul. Promis." },
          {
            t: "ul",
            c: [
              "Nous vous formons sur la plateforme, les offres et les méthodes de vente.",
              "Nous vous suivons avec un coaching commercial personnalisé et des coachings réguliers pour améliorer vos performances.",
              "Nous vous formons en continu sur les évolutions de l'IA et les nouveaux cas d'usage.",
              "Nous vous fournissons des outils, des argumentaires, des démos prêtes à l'emploi… et même des agents IA ;) pour que vous soyez opérationnel rapidement.",
            ],
          },
          { t: "p", c: "Bref, nous mettons tout en œuvre pour que vous réussissiez durablement votre activité." },
        ],
      },
      {
        title: "Une évolution basée sur vos performances",
        blocks: [
          { t: "p", c: "→ À partir de 1 500 € de MRR générés : Un prospecteur dédié rejoint votre équipe pour vous fournir des rendez-vous qualifiés. Vous pourrez le former et le manager afin d'accélérer votre développement." },
          { t: "p", c: "→ À partir de 4 000 € de MRR générés : Nous finançons une campagne Google Ads dédiée à votre secteur géographique pour générer encore davantage d'opportunités commerciales." },
          { t: "p", c: "Plus vous développez votre portefeuille, plus Tchatix investit dans votre réussite." },
        ],
      },
      {
        title: "Pourquoi rejoindre Tchatix ?",
        blocks: [
          { t: "p", c: "Le marché de l'IA est en train de tout changer, et les entreprises n'ont jamais eu autant besoin de solutions concrètes. C'est là qu'on intervient." },
          { t: "p", c: "On a fondé Tchatix en 2025 avec une idée simple : rendre l'IA vraiment utile aux PME et ETI. Des agents qui marchent, centralisés, sécurisés, adaptés à chaque métier." },
          { t: "p", c: "Depuis, les choses vont vite. Bpifrance a subventionné via France 2030, on fait partie du OVHcloud Startup Program, et on commence à faire parler de nous dans les médias (BFM Business). Mais le plus important, c'est ce qu'on construit : une équipe, une plateforme, et un réseau de partenaires qui grandit avec nous." },
          { t: "p", c: "Si vous voulez construire un revenu récurrent sur un marché porteur, avec une équipe qui a de l'ambition et les moyens de ses ambitions → vous êtes au bon endroit." },
          { t: "p", c: "🌐 tchatix.ai" },
        ],
      },
      {
        title: "Le profil recherché",
        blocks: [
          { t: "p", c: "Nous cherchons quelqu'un qui soit :" },
          {
            t: "ul",
            c: [
              "Autonome et organisé.",
              "À l'aise dans la vente B2B, de préférence avec une expérience dans la tech, le SaaS ou les services aux entreprises.",
              "Capable de parler aux dirigeants et de leur montrer concrètement ce que l'IA peut faire pour eux.",
              "Attiré par les nouvelles technologies et l'IA.",
              "Ambitieux, persévérant et orienté résultats.",
            ],
          },
          { t: "p", c: "Pas d'expérience dans la vente tech mais ultra motivé ? Pas de problème, nous formons les talents. Nous recherchons avant tout des personnalités qui souhaitent construire une carrière sur un marché d'avenir, avec un modèle de rémunération évolutif et un accompagnement leur permettant d'atteindre leur plein potentiel." },
          { t: "p", c: "Vous vous reconnaissez ? Contactez-nous, et échangeons !" },
        ],
      },
      {
        title: "Avantages",
        blocks: [
          {
            t: "ul",
            c: [
              "Horaires flexibles",
              "Programme de formation",
              "Lieu du poste : Télétravail",
            ],
          },
        ],
      },
    ],
  },
  {
    slug: "stagiaire-communication",
    title: "Stagiaire en Communication & Contenu (H/F)",
    location: "Télétravail",
    city: "France",
    region: "Télétravail",
    postalCode: "",
    contract: "Stage",
    type: "6 mois",
    remote: "Télétravail",
    employmentType: "INTERN",
    telecommute: true,
    datePosted: "2026-09-18",
    validThrough: "2026-12-31",
    excerpt:
      "Pilotez la stratégie de communication de Tchatix, animez nos agents IA communication et créez du contenu viral, en stage full remote.",
    intro: [
      "Tchatix conçoit des agents IA sur mesure pour les métiers des PME et ETI. Notre plateforme permet de créer, partager, automatiser et piloter des équipes d'agents IA métier dans un environnement sécurisé et conforme RGPD.",
      "Pour accélérer notre visibilité, nous recherchons un ou une stagiaire en communication pour monter notre stratégie de communication, piloter nos agents IA communication et créer du contenu viral.",
    ],
    sections: [
      {
        title: "Votre mission",
        blocks: [
          { t: "p", c: "Vous bâtissez et faites vivre la stratégie de communication de Tchatix, en vous appuyant sur nos agents IA pour produire du contenu à grande échelle." },
        ],
      },
      {
        title: "Vos missions",
        blocks: [
          {
            t: "ul",
            c: [
              "Monter et structurer la stratégie de communication de Tchatix.",
              "Piloter les agents IA communication (SEO, social media, community management) pour produire du contenu à volume.",
              "Créer du contenu viral (posts, vidéos courtes, carrousels, threads) sur les réseaux sociaux.",
              "Animer les comptes LinkedIn, Instagram, YouTube et autres canaux de la marque.",
              "Suivre les performances et itérer sur les formats qui convertissent.",
              "Coordonner la communication autour des événements, partenariats et médias (BFM Business, etc.).",
            ],
          },
        ],
      },
      {
        title: "Profil recherché",
        blocks: [
          {
            t: "ul",
            c: [
              "Étudiant(e) en école de communication, marketing digital ou journalisme.",
              "Créatif(ve), à l'aise avec les réseaux sociaux et les formats vidéo courts.",
              "Intérêt fort pour l'IA générative et les nouveaux usages du contenu.",
              "Autonome, organisé(e) et orienté(e) résultats.",
              "Une première expérience en création de contenu / community management est un plus.",
            ],
          },
        ],
      },
      {
        title: "Avantages",
        blocks: [
          {
            t: "ul",
            c: [
              "Stage en télétravail, horaires flexibles",
              "Immersion dans une startup IA en pleine croissance",
              "Accompagnement et formation aux agents IA Tchatix",
            ],
          },
        ],
      },
    ],
  },
];

export function getJobBySlug(slug) {
  return JOBS.find((j) => j.slug === slug) || null;
}

// Description HTML complète (Google Jobs exige une description en HTML).
export function buildDescriptionHtml(job) {
  const intro = (job.intro || []).map((p) => `<p>${p}</p>`).join("");
  const sections = (job.sections || [])
    .map((s) => {
      const blocks = s.blocks
        .map((b) =>
          b.t === "ul"
            ? `<ul>${b.c.map((x) => `<li>${x}</li>`).join("")}</ul>`
            : `<p>${b.c}</p>`
        )
        .join("");
      return `<h3>${s.title}</h3>${blocks}`;
    })
    .join("");
  return intro + sections;
}

// JSON-LD JobPosting conforme aux consignes Google.
// (https://developers.google.com/search/docs/appearance/structured-data/job-posting)
export function jobPostingLd(job, path) {
  const ld = {
    "@context": "https://schema.org",
    "@type": "JobPosting",
    title: job.title,
    description: buildDescriptionHtml(job),
    datePosted: job.datePosted,
    validThrough: job.validThrough,
    employmentType: job.employmentType || "FULL_TIME",
    directApply: true,
    hiringOrganization: {
      "@type": "Organization",
      name: SITE_NAME,
      sameAs: SITE_URL,
      logo: DEFAULT_OG_IMAGE,
    },
    jobLocation: {
      "@type": "Place",
      address: {
        "@type": "PostalAddress",
        addressLocality: job.city,
        addressRegion: job.region,
        postalCode: job.postalCode || undefined,
        addressCountry: "FR",
      },
    },
    identifier: {
      "@type": "PropertyValue",
      name: SITE_NAME,
      value: job.slug,
    },
  };
  if (job.telecommute) {
    ld.jobLocationType = "TELECOMMUTE";
    // Google exige, pour les postes 100% télétravail, d'indiquer au moins un
    // pays d'éligibilité des candidats. On restreint à la France.
    ld.applicantLocationRequirements = {
      "@type": "Country",
      name: "France",
    };
  }
  if (path) ld.url = SITE_URL.replace(/\/$/, "") + path;
  return ld;
}